import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tooltip } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

const TrendIndicator = ({ direction, size = 'small' }) => {
  const config = {
    improving: { icon: <TrendingUpIcon fontSize={size} />, color: 'success.main', label: 'Improving' },
    declining: { icon: <TrendingDownIcon fontSize={size} />, color: 'error.main', label: 'Declining' },
    stable: { icon: <TrendingFlatIcon fontSize={size} />, color: 'info.main', label: 'Stable' },
  };
  const { icon, color, label } = config[direction] || config.stable;
  return (
    <Tooltip title={label}>
      <Box sx={{ color, display: 'flex', alignItems: 'center' }}>{icon}</Box>
    </Tooltip>
  );
};

TrendIndicator.propTypes = {
  direction: PropTypes.string,
  size: PropTypes.string,
};

export default TrendIndicator;